module.exports = __webpack_public_path__ + "img/table.5bc0d14.png";